import { Alert, Button, Form, Modal, Spinner } from "react-bootstrap";
import CloseBtn from "../CloseBtn";

const ImportUserModal = ({
  show,
  onHide,
  handleFileUpload,
  uploadType,
  setUploadType,
  importing,
  importSuccess,
  importReport,
  onClose,
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="md"
      centered
      backdrop={importing ? "static" : true}
      keyboard={!importing}
    >
      {!importing && <CloseBtn onClick={onHide} color="#bf352b" />}
      <Modal.Header>
        <Modal.Title>Upload Excel File</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {importing ? (
          <div className="text-center my-4">
            <Spinner animation="border" role="status" />
            <div className="mt-2">Importing… please wait</div>
          </div>
        ) : (
          <>
            {/* File select form */}
            <Form.Group className="mb-3" controlId="upload_type">
              <Form.Label>Upload Type</Form.Label>
              <Form.Select
                value={uploadType}
                onChange={(e) => setUploadType(e.target.value)}
              >
                <option value="create">Create New Users</option>
                <option value="update">Update Existing Users</option>
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3" controlId="upload_file">
              <Form.Label>Upload File</Form.Label>
              <Form.Control
                type="file"
                accept=".xlsx,.xls"
                onChange={handleFileUpload}
              />
            </Form.Group>
            <Alert variant="info">Accepted formats: .xlsx, .xls</Alert>

            {/* Show result after import */}
            {importSuccess === true && importReport && (
              <Alert variant="success" className="mt-3">
                {importReport.totalRows} rows processed successfully!
              </Alert>
            )}
            {importSuccess === false && importReport && (
              <Alert variant="danger" className="mt-3">
                Import failed with {importReport.errorCount} errors.
              </Alert>
            )}
          </>
        )}
      </Modal.Body>

      <Modal.Footer>
        {importing ? (
          <Button variant="secondary" disabled>
            <Spinner animation="border" size="sm" className="me-2" />
            Importing…
          </Button>
        ) : (
          <Button variant="secondary" onClick={onClose || onHide}>
            Close
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default ImportUserModal;
